import React from "react";

/**
 * Section heading with the design system's signature "accent bar"
 * + bold heading + optional eyebrow + description.
 */
export default function SectionHeading({ eyebrow, title, description, align = "left", invert = false }) {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  const titleColor = invert ? "text-white" : "text-slate-900";
  const descColor = invert ? "text-slate-300" : "text-slate-600";
  const eyebrowColor = invert ? "text-[#EAB308]" : "text-[#0F172A]";

  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl ${align === "center" ? "mx-auto" : ""}`}>
      <span className="accent-bar mb-5" />
      {eyebrow && (
        <p className={`uppercase tracking-[0.2em] text-xs font-semibold mb-3 ${eyebrowColor}`}>
          {eyebrow}
        </p>
      )}
      <h2 className={`font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold ${titleColor}`}>
        {title}
      </h2>
      {description && (
        <p className={`mt-5 text-base lg:text-lg leading-relaxed ${descColor}`}>
          {description}
        </p>
      )}
    </div>
  );
}
